// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","PanelFooter":"bcx_a bhp_b bhp_va bhp_rv bhp_rw bhp_vu","PanelFooter--link":"bcx_b"};